import React from 'react';

import Checkbox from '../../checkbox';

const CheckboxCell = ({ onSelect, checked, color, header }) => {
  return (
    <td className="column checkbox">
      <Checkbox checked={checked} color={color} onSelect={onSelect} />
    </td>
  );
};

export default CheckboxCell;
